import { render, staticRenderFns } from "./CreateOnkPartners.vue?vue&type=template&id=4fc8670c&"
import script from "./CreateOnkPartners.vue?vue&type=script&lang=js&"
export * from "./CreateOnkPartners.vue?vue&type=script&lang=js&"
import style0 from "./CreateOnkPartners.vue?vue&type=style&index=0&id=4fc8670c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports